const RULER_ID = 'VHChecker';
let height_cache = 0;
let ruler;

const makeRuler = () => {
	let el = document.createElement('div');
	el.id = RULER_ID;
	Object.assign( el.style, {
		position: 'fixed',
		height: '100vh', 
		top: 0, width: 0,
		visibility: 'hidden',
		pointerEvents: 'none',
		zIndex: -999
	} )
	document.body.appendChild(el);
	return el;
}

const onResize = () => {
	height_cache = ruler.offsetHeight || window.innerHeight;
}

const getVHInPixel = (vh=100) => {
	return height_cache * vh / 100;
}

const getPixelInVH = (px=0) => {
	return px / (height_cache / 100);
}

if ( typeof document !== 'undefined' ) {
	ruler = makeRuler();
	window.addEventListener('resize', onResize);
	onResize();
} else {
	height_cache = 800; // default value for SSR
}


export { getVHInPixel, getPixelInVH };


// WEBPACK FOOTER //
// ./src/utils/VHChecker.jsx